import { render, staticRenderFns } from "./AdminRequestsListView.vue?vue&type=template&id=422475be&scoped=true"
import script from "./AdminRequestsListView.vue?vue&type=script&lang=js"
export * from "./AdminRequestsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422475be",
  null
  
)

export default component.exports